import EventsComponent from "./events.component";

export default EventsComponent;
